import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCountries, getbundles, createCart } from "../api/index";
import { toast } from "react-toastify";
import Header from "../../header";
import styles  from  "../styles/style.module.css";
import destination from "../../../assets/images/destination.png";
import contrybanner from "../../../assets/images/contrybanner.svg";
import check from "../../../assets/images/checkuili_green.svg";
import search from "../../../assets/images/search.svg";
import Footer from "../../footer";
import InstallationGuide from "../../globaltix/InstallationGuide";
import BlogSlider from "../../globaltix/BlogSlider/BlogSlider";

const PARTNER_WEBSITE_ID = "6798f6584c9989f41ae281d";

const CountrySelectPage = () => {
  const [searchCountry, setSearchCountry] = useState<string>("");
  const [countriesData, setCountriesData] = useState<any>({ items: [], count: 0 });
  const [couponId, setCouponId] = useState<string>(""); // If you want to support coupon
  const navigate = useNavigate();

  useEffect(() => {
    const query: any = {
      page: 1,
      limit: 12,
      partnerWebsiteId: '667000f74e37cd362882386e',
    };
    if (searchCountry) {
      query.searchString = searchCountry;
    }
    getCountries(query, PARTNER_WEBSITE_ID)
      .then((res: any) => {
        setCountriesData({
          items: res?.data?.countries,
          count: res?.data?.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [searchCountry, couponId]);

  const cartCreate = (countryId: string) => {
    getbundles({
      // dataAmount: 2000,
      // duration: 15,
      countryId,
      isCountry: true,
    },"6798f6584c9989f41ae281d")
      .then((res: any) => {
        console.log(res, "res=====");
        if (res?.data[0]?._id && res?.statusCode === 200) {
          createCart({
            items: [
              {
                bundleId: "67ac54d7a43398c782c049a3",
                quantity: 1,
                price: Number(res?.data[0]?.price),
                countryId: countryId,
                Partnerwebsiteid: "6719f9721bba1b02d47447af"
              },
            ],
            // scratchCoupanId: couponId,
            cartType: 2,
          })
            .then((res: any) => {
              console.log(res, "res");
              if (res?.statusCode === 201 && res?.data?._id) {
                navigate(`/checkout/${res?.data?._id}?country=${countryId}`);
              }
            })
            .catch(() => { });
        }
        // setBundlesData({ items: res?.data, count: res?.count });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Sorry!! Plan not fount")
      });
  };
 const [isOn, setIsOn] = useState(false);
  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className={`${styles.topbanner} row align-items-center`}>
          <div className="col-lg-6 col-12">
              <span className={`${styles.esimbuy} border border-1 rounded-pill p-3 d-inlne-block mx-0`}>
          
                <i className="me-2"><img
                  width={25}
                  height={25}
                  src={check}
                  alt="country"
                /></i>
                1 GB DATA FREE
              </span>
              <div className={`${styles.blogrecent} mt-4`}>
        
                <>
                  <h2 className="mb-3 text-black fw-semibold">Choose eSIM from your destination <br/>country</h2>
                  <p className="">Stay connected abroad with an eSIM from your destination country. Instant activation and local data rates.</p>
                </>
              </div>
          </div>
          <div className="col-lg-6 col-12 text-center">
            <figure className="mb-0"><img src={destination} alt="" className="img-fluid"/></figure>
          </div>        
        </div>
      </div>
      
      <div className="country-select-page">
        <div className="container-fluid">
          <div className={styles.changecountry}>
            {/* <h3>Select <span className="d-md-inline-block d-none"> your destination</span> country</h3> */}
            <div className="col-12">
              <div className="row align-items-center justify-content-start g-3 flex-row mb-4">
                <div className="col-lg-6 col-8">
                  <div className="leftfilter position-relative">
                  <i><img src={search} alt="" width={15} height={15} /></i>
                  <input
                    type="text"
                    placeholder="Search Country"
                    className="form-control bg-white border"
                    value={searchCountry}
                    onChange={(e) => setSearchCountry(e.target.value)}
                  />
                </div>
                </div>
                <div className="col-lg-6 col-4 text-end"> 
                  <label className={styles.customtoggle}>
                  <input type="checkbox" id="toggleRegion" checked={isOn}  onChange={() => setIsOn(!isOn)}/>
                  <span className={`${styles.slider} ${isOn ? styles.on : styles.off}`}>
                      {isOn ? "OFF" : "Region"}
                    </span>
                </label>
                </div>
              
              
              </div>
            </div>
            <div className="countryList">
              <ul className="row align-items-center justify-content-start g-xl-4 g-lg-3 g-2 p-0">
                {countriesData?.items?.length > 0 ? (
                  countriesData?.items?.map((item: any, index: number) => (
                    <li
                      className="col-xl-3 col-md-4 col-6"
                      key={index}
                      onClick={() => cartCreate(item?._id)}
                    >
                      <div
                       style={{cursor: "pointer",backgroundColor: "white",background:`url(${item?.commbitzImageUrlFull}) no-repeat center center`
                        
                       }} 
                       className="contrylist px-3">
                      <div className="contrylistinglist d-flex align-items-center justify-content-center">
                        <div className="col-3 text-center">
                          <img src={item?.flagImageUrl} alt="" className="img-fluid shadow-sm rounded-circle"/>
                        </div>
                        <div className="col-9">
                          <h4 className="clamp clamp1 mb-0">{item?.name}</h4>     
                          <p className="mb-0">Start From USD 5.00</p>                 
                        </div>
                      </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <div> Country not found. </div>
                )}
              </ul>
              {/* <ul>
              {countriesData?.items?.length > 0 ? (
                countriesData?.items?.map((item: any, index: number) => (
                  <li key={index} onClick={() => cartCreate(item?._id)}>
                    <img src={item?.flagImageUrl} alt="" />
                    <span>{item?.name}</span>
                  </li>
                ))
              ) : (
                <div>Country not found.</div>
              )}
            </ul> */}
            </div>
          </div>
        </div>
      </div>
      <InstallationGuide />
      <BlogSlider />
      <Footer />
    </>
  );
};

export default CountrySelectPage; 